import { Component, HostListener, signal, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

import { SidebarComponent } from '../../shared/sidebar/sidebar.component';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { BottomTabBarComponent } from '../../shared/bottom-tab-bar/bottom-tab-bar.component';
import { GlobalSearchPaletteComponent } from '../../shared/global-search/global-search-palette.component';
import { VdToastHostComponent } from '../../ui/toast/toast-host.component';
import { ThemeService } from '../../ui/theme.service';
import { OnboardingFabComponent } from '../../shared/onboarding-cta/onboarding-fab.component';
import { OnboardingDrawerComponent } from '../../shared/onboarding-cta/onboarding-drawer.component';
import { VendorStatusBannerComponent } from '../../shared/vendor-status-banner/vendor-status-banner.component';
import { BusinessOnboardingService } from '../../services/business-onboarding.service';
import { RealtimeService } from '../../services/realtime.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    SidebarComponent,
    NavbarComponent,
    BottomTabBarComponent,
    GlobalSearchPaletteComponent,
    VdToastHostComponent,
    OnboardingFabComponent,
    OnboardingDrawerComponent,
    VendorStatusBannerComponent,
    RouterOutlet,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit, OnDestroy {
  readonly mobileDrawerOpen = signal<boolean>(false);
  private theme = inject(ThemeService); // s'assure que le service est initialisé
  // Le service onboarding est instancié au montage du shell pour qu'il
  // charge l'état dès que l'utilisateur est connecté et suive la navigation.
  readonly onboarding = inject(BusinessOnboardingService);
  // Shell authentifié : on ouvre le transport temps réel (SSE) une fois ici,
  // additif et best-effort (le service est SSR-safe et ne lève jamais).
  private readonly realtime = inject(RealtimeService);

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.mobileDrawerOpen.set(false));
    this.realtime.connect();
  }

  ngOnDestroy(): void {
    this.realtime.disconnect();
  }

  onToggleSidebar(): void {
    this.mobileDrawerOpen.update((v) => !v);
  }

  closeDrawer(): void {
    this.mobileDrawerOpen.set(false);
  }

  @HostListener('document:keydown.escape')
  onEsc(): void {
    this.mobileDrawerOpen.set(false);
  }
}
